helpers = require("./helpers.coffee")

# Counter for unique IDs
idCounter = 0

uniqueId = (prefix="") ->
    ++idCounter
    "#{prefix}#{idCounter}"

# Via http://stackoverflow.com/a/15150381
findBootstrapEnvironment = () ->
    envs = ["lg", "md", "sm", "xs"]

    el = $("<div>&nbsp;</div>")
    el.appendTo($("body"))

    for env in envs
        el.addClass("hidden-#{env}")

        if el.is(":hidden")
            el.remove()
            return env

# get the screen size and translate it to human text
humanBootstrapEnvironment = () ->
    screenSize = findBootstrapEnvironment()
    if screenSize == "xs"
        display = "mobile"
    else if screenSize == "md" or screenSize == "sm"
        display = "tablet"
    else
        display = "desktop"

    display

# Gets the value of a cookie with the specified name
getCookie = (name) ->
    r = document.cookie.match("\\b#{name}=([^;]*)\\b")
    return if r then r[1] else undefined

# sets a cookie on the number of days it should exist for
setCookie = (name, value, days, path, domain) ->
    expires = ''

    if days
        date = new Date()
        # set the date to the number of miliseconds when the cookie
        # should expire
        date.setTime(date.getTime() + days*24*60*60*1000)
        # cookies require date in UTC/GMT format
        expires = "; expires=#{date.toGMTString()}"

    path = if path then "; path=#{path}" else ''
    domain = if domain then "; domain=#{domain}" else ''

    document.cookie = "#{name}=#{value}#{expires}#{path}#{domain}; samesite=none; secure"

deleteCookie = (name, path="/", domain) ->
    setCookie(name, "", 0, path, domain)


# find a parent elt of a given tag by it's tag name
findParentElt = ($elt, tagName) ->
    while $elt.prop("tagName") != tagName
        $elt = $elt.parent()

    $elt

# track a page in google analytics - should be used for client side ga tracking
# ex. on spa page navigation
#
# @param [String] pageName the page name to track in ga
# @param [String] title the page title to record
#
trackPage = (pageName, title) ->
    pageViewData = {
        page: pageName
    }

    # only add title to the object if it exists
    if title then pageViewData.title = title

    try
        ga("set", pageViewData)
        ga('send', 'pageview')

# flexible method used to track ga and oskar
#
# @param [Object] opts the track options
# @option opts [String] oskarEvent the name of the oskar event
# @option opts [String] oskarOpts the oskar options to trak
# @option opts [String] gaCat the name of the ga Category to track
# @option opts [String] gaAction the name of the ga Action
# @option opts [String] gaLabel optional, the name of the ga label to track
# @option opts [Function] cb optional, a cb after ga + mp are successful
#
track = (opts) ->
    {oskarEvent, oskarOpts, gaCat, gaAction, gaLabel, cb} = opts

    if not gaCat or not gaAction
        throw new Error("Google analytics action or category not defined")

    if not oskarEvent
        throw new Error("Oskar event name not defined")

    # flags whether oskar and ga tracking calls were successful
    oskarSubmit = false
    gaSubmit = false

    # whether the cb was invoked used in the settimeout to only call the cb once
    # after oskar + ga have been successful or if they failed
    cbInvoked = false

    # need to check if a call back exists and that the type of cb is a function
    cbExists = opts.cb? and typeof opts.cb == "function"

    # object to pass to ga function - used to conditionally add other options
    # that aren't always present
    gaOpts = {
        "hitType": "event",
        "eventCategory": gaCat,
        "eventAction": gaAction,
        "nonInteraction": 1,
        "hitCallback": () ->
            gaSubmit = true
            submitCb()
    }

    # because an eventLabel is optional for google analytics we want to maintain
    # that in our wrapper
    if "gaLabel" of opts
        gaOpts.eventLabel = gaLabel

    submitCb = () ->
        # only call the callback if it exists mp and ga and oskar have submited and the cb
        # hasn't been invoked
        if cbExists and gaSubmit and oskarSubmit and not cbInvoked
            cbInvoked = true
            cb()

    muse.track(oskarEvent, oskarOpts, () =>
        oskarSubmit = true
        submitCb()
    )

    try
        ga("send", gaOpts)
    catch
        gaSubmit = true
        submitCb()

    # in case the ga call and/or the oskar tracking fails, still want to
    # call the cb, but this should only be done if there is a cb
    if cbExists
        setTimeout(() ->
            if not cbInvoked then cb()
            cbInvoked = true
        , 2000)

# called by views to track links returns whether the link should return false
# or true. Also publishes a mithril coat event for the click
#
# @param [jQuery Event Object] e the event from the link being clicked
# @param [String] coatEventName the name of the mithril coat event to publish
# @param [Dom Node] $target the javascript dom node that was clicked (NOTE: if
# you have a reference to a jQuery object pass that in as $el[0])
# @param [Object] coatOpts the coat properties to be passed to the mithril coat
# event
#
trackLink = (e, coatEventName, $target, coatOpts={}) ->
    # determine whether user attempted to open the link in a new tab or
    # clicked directly on the link
    coatOpts.newTab = if e.which == 2 or e.which == 3 or e.ctrlKey or e.shiftKey or e.metaKey or $target.target == "_blank" then true else false

    #if the event is a right click, always add right_click property to the link tracking obj
    if e.which == 3
        coatOpts.rightClick = true

    # if the link is an internal link we can prevent the default behaviour
    if not coatOpts.newTab
        e.preventDefault()

    if not coatOpts.link then coatOpts.link = $target.getAttribute("href")

    coat.publishSync(coatEventName, coatOpts)

    true

# track resize and publish mithril coat even on resize
#
# @param [String] eventName the event name to publish on window resize
#
trackResize = (eventName) ->
    prevWidth = window.museWidth

    $(window).on('resize', helpers.throttle(() ->
        curWidth = window.getWidth()
        window.museWidth = curWidth

        # did the display change from desktop to mobile or mobile to desktop or
        # tablet to desktop or desktop to tablet
        isResized = (curWidth >= muse.consts.MOBILE_WIDTH and prevWidth < muse.consts.MOBILE_WIDTH) or (curWidth < muse.consts.MOBILE_WIDTH and prevWidth >= muse.consts.MOBILE_WIDTH) or (curWidth >= muse.consts.TABLET_WIDTH and prevWidth < muse.consts.TABLET_WIDTH) or (curWidth < muse.consts.TABLET_WIDTH and prevWidth >= muse.consts.TABLET_WIDTH) or (curWidth >= muse.consts.MD_WIDTH and prevWidth > muse.consts.MD_WIDTH) or (curWidth < muse.consts.MD_WIDTH and prevWidth >= muse.consts.MD_WIDTH)

        coat.publishSync(eventName, {
            resized: isResized
        })

        # reset prevWidth to the new width
        prevWidth = curWidth
    , 400))

# get schema org object from rendered view and append to the dom
#
# @param [Object] schemaObj org object compiled from the view.
#
appendSchemaOrgObjToDom = (schemaObj) ->
    $("body").append("<script type=\"application/ld+json\"> #{JSON.stringify(schemaObj)} </script>")

# tests whether an object is an object. NOTE: this will return true for {} or []
# but not functions
isObject = (obj) ->
    obj == Object(obj)

# Adds a callback to fire on page load. This is used instead of `$.ready`
# because `$.ready` does not interact well with `window.onload` (according
# to the documentation), and third-party libs may use `window.onload`.
addWindowOnLoadListener = (cb) ->
    window.addEventListener("load", cb)

hasExperimentArms = (experimentName, arms...) ->
    arms.indexOf(muse.experiments[experimentName]) != -1


# generates ellipsis when element's height greater than maxHeight:
# this only adds an `overflow` css class when an ellipsis is necessary
# to be used together with `@mixin ellipsis` styling
createEllipsis = ($el, maxHeight) ->
    if $el.height() > maxHeight
        $el.addClass("overflow")

    $el.css("height", maxHeight + "px")

# Removes focus from the current active element
clearFocus = () ->
    # Check for body because some browsers use the body element instead of null
    # as the default value
    # https://developer.mozilla.org/en-US/docs/Web/API/Document/activeElement
    if document.activeElement and document.activeElement != document.body
        document.activeElement.blur()

# Used to get the path the current coat route
coatPath = () ->
    coat.route().split("?")[0]

module.exports = {
    uniqueId: uniqueId,
    findBootstrapEnvironment: findBootstrapEnvironment,
    humanBootstrapEnvironment: humanBootstrapEnvironment,
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
    findParentElt: findParentElt,
    trackPage: trackPage,
    track: track,
    trackResize: trackResize,
    trackLink: trackLink,
    appendSchemaOrgObjToDom: appendSchemaOrgObjToDom,
    isObject: isObject,
    addWindowOnLoadListener: addWindowOnLoadListener,
    hasExperimentArms: hasExperimentArms,
    createEllipsis: createEllipsis,
    clearFocus: clearFocus,
    coatPath: coatPath
}



// WEBPACK FOOTER //
// ./node_modules/musecoreui/util/util.coffee